import angular from 'angular'
import taxAccount from './view/taxAccount.html'

class taxAccountComponent {
    constructor(httpRequest, sweetalert) {
        const scope = this
        scope.isCollapsed = false
        scope.queryParam = {
            pageNum: 1,
            pageSize: 10,
            param: {
                swkjkmDmAndSwkjkmmc: '',
                accessToken: localStorage.getItem('id_token'),
            },
        }
        scope.reset = function () {
            scope.queryParam.param = {
                swkjkmDmAndSwkjkmmc: '',
                accessToken: localStorage.getItem('id_token'),
            }
        }
        // scope.reset()
        scope.queryList = function queryList() {
            httpRequest.post_getSbSwkjkmDmList(scope.queryParam).then((res) => {
                scope.listData = res.data.value.list
                scope.totalItems = res.data.value.total
                scope.queryParam.pageNum = res.data.value.pageNum
            })
        }
        scope.queryList()
        scope.importconfig = {
            code: 'SWKJKM',
            validate: {
                pattern: '.xlsx,.xls',
                _validate: {
                    size: { min: 10, max: '10MB' },
                    duration: { min: '10s', max: '5m' },
                    accept: '.xlsx,.xls',
                },
            },
            appName: host.etcloudSb,
            hideDownload: true,
            callback() {
                scope.queryList()
            },
        }
        scope.upload = function upload() {
            sweetalert.confirm('操作提醒', '导入后将全面覆盖已有的税务会计科目表，确定要导入吗？').then(() => {
                angular.element('#tax-account-upload .plbtngrouptxt').click()
            })
        }
        // 表头排序
        scope.orderMap = { sortKey: '', sortVal: '' }
        scope.selectedHandle = function selectedHandle() {
            scope.queryParam.orderMap = {}
            if (scope.orderMap.sortKey) scope.queryParam.orderMap[scope.orderMap.sortKey] = scope.orderMap.sortVal
            scope.queryList()
        }
        // 导出
        scope.exportTaxClass = function exportTaxClass() {
            httpRequest.get_exportSbKjkmDmToExcel(scope.queryParam.param)
        }

        // 模板下载
        scope.downloadExcel = function () {
            window.open(`${host.etcloudSb}dl/dlTaskService/export_SWKJMK_OUT?accessToken=${localStorage.getItem('id_token')}`)
        }
    }
}
taxAccountComponent.$inject = ['httpRequest', 'sweetalert']
export default angular.module('system.basedata.taxPolicy.taxAccount', [])
    .controller('taxAccountComponent', taxAccountComponent)
    .component('taxAccount', {
        controller: 'taxAccountComponent',
        template: taxAccount,
    }).name



// WEBPACK FOOTER //
// ./src/app/system/basedata/taxClass/taxAccountComponent.js